import { Field } from 'formik';
import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from '../../../entities/filters/base-url-params-filter';
import { TextField } from 'formik-mui';

export const InputParamFilter = ({ queryParamName, label, size = 'medium' }: BaseUrlParamsFilterProps) => {
  return (
    <BaseUrlParamsFilter queryParamName={queryParamName}>
      <Field fullWidth name={queryParamName} label={label} component={TextField} />
    </BaseUrlParamsFilter>
  );
};
